module.exports = __webpack_public_path__ + "static/img/A20.28c89100.jpg";